import { render } from "./CorsePage.vue?vue&type=template&id=cb30dcf6&scoped=true"
import script from "./CorsePage.vue?vue&type=script&lang=js"
export * from "./CorsePage.vue?vue&type=script&lang=js"

import "./CorsePage.vue?vue&type=style&index=0&id=cb30dcf6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb30dcf6"]])

export default __exports__